import { appConfig } from '../config/runtime-config'

const
    devConsoleLog = (appConfig.environment === 'development') ? console.log : () => {},
    httpMethods = {
        get: 'get',
        post: 'post',
        patch: 'patch',
        delete: 'delete',
    },
    buildErrorAndThrow = error => { throw (typeof error === 'object') ? error : new Error(error) }

export { devConsoleLog, httpMethods, buildErrorAndThrow }
